import { useEffect, useState } from 'react'

import { listVariables } from '@services/sm-api.js'

// V2 como experiência oficial na raiz (decisão de 10/09/2026).
// A rota "/" renderiza a home V2 DIRETAMENTE (sem redirect). O interruptor de
// retorno é a variável CHECKOUT_V2_OFF (tabela variables): valor '1' devolve a
// home V1; ausente ou qualquer outro valor mantém a V2. A variável antiga
// CHECKOUT_V2 (que redirecionava para /v2) deixa de ter efeito — ambientes com
// o registro legado '0' NÃO voltam ao V1 por acidente. As rotas /v2/* continuam.
//
// Para evitar "piscar" a home errada enquanto a variável carrega, a última
// resposta fica em localStorage (smd_v2_official) e o padrão é V2.
const CACHE_KEY = 'smd_v2_official'
let known = null // null = ainda não consultado nesta sessão
let pending = null
const listeners = new Set()

const readCache = () => {
  try {
    return localStorage.getItem(CACHE_KEY) !== '0'
  } catch (e) {
    return true
  }
}

const writeCache = value => {
  try {
    localStorage.setItem(CACHE_KEY, value ? '1' : '0')
  } catch (e) {
    /* storage indisponível: segue só em memória */
  }
}

export function resolveV2Official() {
  if (known !== null) return Promise.resolve(known)
  if (!pending) {
    pending = listVariables()
      .then(response => {
        const variables = (response && response.variables) || response || []
        const flag = Array.isArray(variables) ? variables.find(v => v.key === 'CHECKOUT_V2_OFF') : null
        known = !(flag && String(flag.value) === '1')
        writeCache(known)
        listeners.forEach(fn => fn(known))
        return known
      })
      .catch(() => {
        known = readCache()
        return known
      })
  }
  return pending
}

// Hook: valor imediato (cache ou padrão V2) e atualização quando a API responder.
export function useV2Official() {
  const [official, setOfficial] = useState(known !== null ? known : readCache())
  useEffect(() => {
    let alive = true
    const fn = value => alive && setOfficial(value)
    listeners.add(fn)
    resolveV2Official().then(fn)
    return () => {
      alive = false
      listeners.delete(fn)
    }
  }, [])
  return official
}

// Variante para decisões que não voltam atrás (redirect /admin → V2): null até a
// API responder — o cache/padrão V2 do useV2Official mandaria para o V2 mesmo com
// o kill switch ligado num navegador sem cache.
export function useV2OfficialResolved() {
  const [official, setOfficial] = useState(known)
  useEffect(() => {
    let alive = true
    resolveV2Official().then(value => alive && setOfficial(value))
    return () => {
      alive = false
    }
  }, [])
  return official
}

// Rotas que usam o chrome V2 (header/rodapé/assistente próprios)
export const isV2Path = (pathname, official) => pathname.startsWith('/v2') || (!!official && pathname === '/')

// Caminho da home no contexto atual (links do chrome V2)
export const homePath = official => (official ? '/' : '/v2')
